import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../common/types';
import { workspaceInitials } from './workspaceInitials';
import styles from './WorkspaceMark.module.scss';

interface WorkspaceMarkProps {
  licenseId: number;
  name: string;
  size: 'medium' | 'large';
}

// design: workspaces ws.css .h-*. The hue comes from the licence id, so it is stable.
const markHues = [styles.hue0, styles.hue1, styles.hue2, styles.hue3, styles.hue4, styles.hue5];

/** design: workspaces ws.css .wsm: the initials of a workspace on a gradient square. */
const WorkspaceMarkComponent: React.FC<WorkspaceMarkProps> = ({ licenseId, name, size }) => (
  <span
    className={clsx(styles.mark, size === 'large' && styles.large, markHues[licenseId % markHues.length])}
    aria-hidden="true"
  >
    {workspaceInitials(name)}
  </span>
);

export const WorkspaceMark = TypedMemo(WorkspaceMarkComponent);
